import { render, staticRenderFns } from "./saleSiteInfo.vue?vue&type=template&id=545e449a&scoped=true"
import script from "./saleSiteInfo.vue?vue&type=script&lang=js"
export * from "./saleSiteInfo.vue?vue&type=script&lang=js"
import style0 from "./saleSiteInfo.vue?vue&type=style&index=0&id=545e449a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545e449a",
  null
  
)

export default component.exports